import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useFormikContext, FormikProps, FormikValues } from 'formik';
import { Organization } from 'types/schema-generated-types';
import ClassroomDetailsForm from '../ClassroomDetailsForm';
import StepHeader from '../StepHeader';

interface CreateClassStepProps {
  index: number;
  organizations?: Organization[];
  onBlur?: React.FocusEventHandler<HTMLDivElement>;
}

const CreateClassStep = ({ index, organizations, onBlur }: CreateClassStepProps): ReactElement => {
  const classes = useStyles();
  const { t } = useTranslation('CreateClassStep');

  const { values }: FormikProps<FormikValues> = useFormikContext();

  // This is the first step, this is suppose to delay rendering the form fields until
  // the formik instance has changed the form values
  if (!values || values.students) return <div />;

  return (
    <div className={classes.root} onBlur={onBlur}>
      <StepHeader
        title={`${index}. ${t('Class Details')}`}
        subtitle={t(
          'This is the first step in the creation of your new class. Please take a moment to fill out the form below.'
        )}
        maxWidth="sm"
      />
      <ClassroomDetailsForm organizations={organizations || []} />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  header: {
    width: '100%',
    padding: `${theme.spacing(3)}px 0`,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  formContainer: {
    marginTop: theme.spacing(4)
  },
  inputLabel: {
    fontSize: '16px',
    marginBottom: theme.spacing(1)
  },
  input: {
    marginBottom: theme.spacing(3)
  },
  addMoreButtonContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center'
  },
  addMoreButton: {
    marginTop: theme.spacing(3) * -1,
    fontSize: 18,
    textTransform: 'unset',
    padding: '0 16px 0 12px'
  },
  addIcon: {
    marginRight: theme.spacing(1.5),
    fontSize: 28
  },
  danger: {
    color: 'red'
  }
}));

export default CreateClassStep;
